// KURLORA — comportamientos del tema (vanilla JS, sin librerías).
// Varias secciones cargan este archivo: se protege para que solo se ejecute una vez.
(function () {
  if (window.__klScripts) return;
  window.__klScripts = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Apariciones al hacer scroll (un único observador compartido)
  function initReveal() {
    var els = document.querySelectorAll('.kl-reveal, .kl-reveal-img');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('kl-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('kl-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  // Parallax suave del hero (ratón en escritorio + scroll)
  function initParallax() {
    if (reduceMotion) return;
    document.querySelectorAll('[data-kl-parallax]').forEach(function (root) {
      var layers = root.querySelectorAll('[data-kl-depth]');
      var fuerza = parseFloat(root.getAttribute('data-kl-parallax')) || 1;
      if (!layers.length || fuerza === 0) return;
      var mx = 0, my = 0, sy = 0, ticking = false;
      function apply() {
        layers.forEach(function (l) {
          var d = parseFloat(l.getAttribute('data-kl-depth')) * fuerza;
          l.style.transform = 'translate3d(' + (mx * d * 18) + 'px,' + (my * d * 18 + sy * d * -0.08) + 'px,0)';
        });
        ticking = false;
      }
      function req() { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }
      if (window.matchMedia('(hover: hover)').matches) {
        root.addEventListener('pointermove', function (e) {
          var r = root.getBoundingClientRect();
          mx = (e.clientX - r.left) / r.width - 0.5;
          my = (e.clientY - r.top) / r.height - 0.5;
          req();
        });
        root.addEventListener('pointerleave', function () { mx = 0; my = 0; req(); });
      }
      window.addEventListener('scroll', function () {
        var r = root.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        sy = -r.top; req();
      }, { passive: true });
    });
  }

  // Ritual: foto fija que cambia según el paso visible
  function initRitual() {
    document.querySelectorAll('[data-kl-ritual]').forEach(function (root) {
      var pasos = root.querySelectorAll('.kl-ritual-paso');
      var fotos = root.querySelectorAll('.kl-ritual-foto');
      var num = root.querySelector('.kl-ritual-num-grande');
      if (!pasos.length) return;
      function activar(i) {
        pasos.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); });
        fotos.forEach(function (f, k) { f.classList.toggle('is-activa', k === i); });
        if (num) num.textContent = ('0' + (i + 1)).slice(-2);
      }
      activar(0);
      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activar(Array.prototype.indexOf.call(pasos, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { obs.observe(p); });
    });
  }

  // Comparador antes / después
  function initComparador() {
    document.querySelectorAll('.kl-comp').forEach(function (wrap) {
      var despues = wrap.querySelector('.kl-comp-despues');
      var asa = wrap.querySelector('.kl-comp-asa');
      if (!despues || !asa) return;
      var arrastrando = false;
      function set(pct) {
        pct = Math.max(0, Math.min(100, pct));
        despues.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        asa.style.left = pct + '%';
      }
      function pctDe(x) { var r = wrap.getBoundingClientRect(); return ((x - r.left) / r.width) * 100; }
      wrap.addEventListener('pointerdown', function (e) { arrastrando = true; set(pctDe(e.clientX)); });
      window.addEventListener('pointermove', function (e) { if (arrastrando) set(pctDe(e.clientX)); });
      window.addEventListener('pointerup', function () { arrastrando = false; });
      set(parseFloat(wrap.getAttribute('data-inicio')) || 50);
      // pequeño "guiño" la primera vez que aparece, para que se entienda que se arrastra
      if (!reduceMotion && 'IntersectionObserver' in window) {
        var o = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          o.disconnect();
          var t0 = null, base = parseFloat(wrap.getAttribute('data-inicio')) || 50;
          function anim(t) {
            if (arrastrando) return;
            if (!t0) t0 = t;
            var p = (t - t0) / 1600;
            if (p > 1) { set(base); return; }
            set(base + Math.sin(p * Math.PI * 2) * 18);
            requestAnimationFrame(anim);
          }
          requestAnimationFrame(anim);
        }, { threshold: 0.6 });
        o.observe(wrap);
      }
    });
  }

  // Cifras que cuentan al aparecer
  function initCifras() {
    var els = document.querySelectorAll('[data-kl-contar]');
    if (!els.length) return;
    function pinta(el, v) {
      var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      el.textContent = (el.getAttribute('data-pre') || '') + v.toFixed(dec).replace('.', ',') + (el.getAttribute('data-suf') || '');
    }
    function correr(el) {
      var fin = parseFloat(el.getAttribute('data-kl-contar')) || 0;
      if (reduceMotion) { pinta(el, fin); return; }
      var t0 = null, dur = 1800;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        pinta(el, fin * (1 - Math.pow(1 - p, 4)));
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(correr); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { correr(e.target); obs.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { pinta(el, 0); obs.observe(el); });
  }

  // Página de producto: galería, variantes, cantidad, barra fija
  function initProducto() {
    document.querySelectorAll('[data-kl-producto]').forEach(function (root) {
      var principal = root.querySelector('.kl-prod-principal img');
      var minis = Array.prototype.slice.call(root.querySelectorAll('.kl-prod-mini'));
      var actual = 0;

      function verFoto(i) {
        if (!principal || !minis.length) return;
        i = (i + minis.length) % minis.length;
        var src = minis[i].getAttribute('data-full');
        if (!src) return;
        actual = i;
        minis.forEach(function (m, k) { m.classList.toggle('is-activa', k === i); });
        principal.classList.add('is-cambiando');
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          principal.src = src;
          principal.removeAttribute('srcset');
          principal.classList.remove('is-cambiando');
        };
        pre.src = src;
      }
      minis.forEach(function (m, k) { m.addEventListener('click', function () { verFoto(k); }); });
      var prev = root.querySelector('[data-kl-prev]'), next = root.querySelector('[data-kl-next]');
      if (prev) prev.addEventListener('click', function () { verFoto(actual - 1); });
      if (next) next.addEventListener('click', function () { verFoto(actual + 1); });

      var jsonEl = root.querySelector('[data-kl-variantes]');
      var idInput = root.querySelector('input[name="id"]');
      var precioAhora = root.querySelectorAll('[data-kl-precio]');
      var precioAntes = root.querySelector('[data-kl-precio-antes]');
      var ahorro = root.querySelector('[data-kl-ahorro]');
      var boton = root.querySelector('[data-kl-add]');
      var botonBarra = document.querySelector('[data-kl-barra-btn]');
      var stock = root.querySelector('[data-kl-stock]');
      var grupos = root.querySelectorAll('[data-kl-opcion]');
      var moneda = root.getAttribute('data-moneda') || 'EUR';
      var locale = document.documentElement.lang || 'es';

      function dinero(c) {
        try { return new Intl.NumberFormat(locale, { style: 'currency', currency: moneda }).format(c / 100); }
        catch (e) { return (c / 100).toFixed(2) + ' ' + moneda; }
      }

      if (jsonEl && idInput) {
        var variantes = JSON.parse(jsonEl.textContent);
        function seleccion() {
          var sel = [];
          grupos.forEach(function (g) {
            var a = g.querySelector('.is-sel');
            sel[parseInt(g.getAttribute('data-kl-opcion'), 10)] = a ? a.getAttribute('data-valor') : null;
          });
          return sel;
        }
        function buscar() {
          var sel = seleccion();
          return variantes.find(function (v) {
            return v.options.every(function (val, i) { return sel[i] === undefined || sel[i] === null || sel[i] === val; });
          });
        }
        function textoBoton(b, v) {
          if (!b) return;
          b.disabled = !v || !v.available;
          b.textContent = !v ? b.getAttribute('data-no-disp') : (v.available ? b.getAttribute('data-add') : b.getAttribute('data-agotado'));
        }
        function render(inicial) {
          var v = buscar();
          grupos.forEach(function (g) {
            var a = g.querySelector('.is-sel');
            var etq = root.querySelector('[data-kl-opcion-valor="' + g.getAttribute('data-kl-opcion') + '"]');
            if (etq && a) etq.textContent = a.getAttribute('data-etiqueta') || a.getAttribute('data-valor');
          });
          textoBoton(boton, v); textoBoton(botonBarra, v);
          if (!v) { if (stock) stock.hidden = true; return; }
          idInput.value = v.id;
          precioAhora.forEach(function (p) { p.textContent = dinero(v.price); });
          var hayAntes = v.compare_at_price && v.compare_at_price > v.price;
          if (precioAntes) { precioAntes.hidden = !hayAntes; if (hayAntes) precioAntes.textContent = dinero(v.compare_at_price); }
          if (ahorro) {
            ahorro.hidden = !hayAntes;
            if (hayAntes) ahorro.textContent = (ahorro.getAttribute('data-plantilla') || '-[x]%').replace('[x]', Math.round((1 - v.price / v.compare_at_price) * 100));
          }
          if (stock) stock.hidden = !v.available;
          if (!inicial && v.featured_media && minis.length) {
            var idx = minis.findIndex(function (m) { return m.getAttribute('data-media-id') == (v.featured_media && v.featured_media.id); });
            if (idx > -1) verFoto(idx);
          }
          if (window.history && window.history.replaceState && root.hasAttribute('data-url')) {
            window.history.replaceState({}, '', root.getAttribute('data-url') + '?variant=' + v.id);
          }
        }
        grupos.forEach(function (g) {
          g.querySelectorAll('[data-valor]').forEach(function (b) {
            b.addEventListener('click', function () {
              g.querySelectorAll('[data-valor]').forEach(function (x) { x.classList.remove('is-sel'); x.setAttribute('aria-pressed', 'false'); });
              b.classList.add('is-sel'); b.setAttribute('aria-pressed', 'true');
              render();
            });
          });
        });
        render(true);
      }

      var cant = root.querySelector('[data-kl-cant]');
      if (cant) {
        var inp = cant.querySelector('input');
        cant.querySelector('[data-menos]').addEventListener('click', function () { inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) - 1); });
        cant.querySelector('[data-mas]').addEventListener('click', function () { inp.value = (parseInt(inp.value, 10) || 1) + 1; });
      }

      // Barra fija en móvil: aparece cuando el botón principal sale de pantalla
      var barra = document.querySelector('[data-kl-barra]');
      if (barra && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(boton);
        if (botonBarra) botonBarra.addEventListener('click', function () { boton.click(); });
      }
    });
  }

  function init() {
    initReveal(); initParallax(); initRitual(); initComparador(); initCifras(); initProducto();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // En el editor de Shopify, re-inicializa al añadir/editar secciones
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.kl-reveal, .kl-reveal-img').forEach(function (el) { el.classList.add('kl-visible'); });
    initRitual(); initComparador(); initCifras(); initParallax();
  });
})();
